import styled from 'styled-components'
import { colors } from '@atlaskit/theme'

export const CountDown = styled.div`
  font-weight: 400;
  margin-top: 0.4rem;
  color: ${colors.N20};
`
